<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAdvisors()
    })
  },
  methods: {
    getAdvisors () {
      this.$store.dispatch('getAdvisors')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Advisors.vue?5b396c06